import { DashboardMetricSet } from '../../dashboard/dashboard-metric';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-metric-content-top3',
    templateUrl: './dashboard-metric-content-top3.component.html',
    styleUrls: ['./dashboard-metric-content-top3.component.scss', './dashboard-metric.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DashboardMetricContentTop3Component implements OnInit {
    @Input()
    dashboardMetricSet: DashboardMetricSet;

    constructor(private dashboardEventService: DashboardEventService) { }

    ngOnInit() {
    }
}
